import { PureComponent } from "react";
import { componentStyles, appIconsStyels } from "./all-rights-reserved-component.scss.js";
import SinglePaletteIconComponent from "../social-footer/palette-icons/single-palette-icon/single-palette-icon-component";
import MONDAY_FOOTER_LOGO from "/static/svg/monday-logos/monday-footer-logo.svg";
import { withGenericConfig } from "/contexts/generic-config-context";
import LanguagePickerComponent from "/components/core/language-picker/language-picker-component";

class AllRightsReservedComponent extends PureComponent {
  constructor(props) {
    super(props);
  }

  renderAppstoreIcons() {
    const { SocialFooterLinks } = this.props;
    const apps = SocialFooterLinks.apps;
    return Object.keys(apps).map((key) => {
      const appIcon = apps[key];
      const IconComp = appIcon.icon;
      return (
        <div className="app-icons" key={key}>
          <SinglePaletteIconComponent IconComp={IconComp} clickableLink={appIcon.url} title={appIcon.title} />
          <style jsx>{appIconsStyels}</style>
        </div>
      );
    });
  }

  renderLanguagePicker() {
    return <LanguagePickerComponent />;
  }

  getText() {
    const { translate } = this.props;
    return translate("allRightsReserved");
  }

  render() {
    return (
      <div className="all-rights-reserved-component">
        <div>
          <div className="monday-logo-wrapper">
            <a href="/">
              <MONDAY_FOOTER_LOGO />
            </a>
          </div>
          <p className="details">
            {this.getText()} <br />© monday.com
          </p>
        </div>
        <div className="icons-and-language">
          <div className="icons-wrapper">{this.renderAppstoreIcons()}</div>
          <div className="language-picker-wrapper">{this.renderLanguagePicker()}</div>
        </div>
        <style jsx>{componentStyles}</style>
      </div>
    );
  }
}

export default withGenericConfig(AllRightsReservedComponent);
